"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const videoStyles_1 = require("../../styling/videoStyles");
const Icons_1 = tslib_1.__importDefault(require("../Icons"));
const styles_1 = tslib_1.__importDefault(require("./styles"));
function PeerMutedBadge({ classes = { root: {}, icon: {} }, muted, icon = muted ? (react_1.default.createElement(Icons_1.default, { iconName: "microphoneoff", title: "Muted", classes: classes.icon })) : (react_1.default.createElement(Icons_1.default, { iconName: "microphone", title: "Unmuted", classes: classes.icon })), classNames, render, style, color = "black", height, width, activeColor = "red", }) {
    (classes === null || classes === void 0 ? void 0 : classes.root)
        ? (classes.root["& svg"] = {
            color: muted ? activeColor : color !== null && color !== void 0 ? color : "",
            height: height !== null && height !== void 0 ? height : "1.5rem",
            width: width !== null && width !== void 0 ? width : "1.5rem",
        })
        : null;
    (classes === null || classes === void 0 ? void 0 : classes.root) != null
        ? (classes.root["&.muted & svg"] = {
            color: activeColor,
        })
        : null;
    const mergedClasses = (0, videoStyles_1.useStyles)({ source: classes, target: styles_1.default }, "peerMutedBadge");
    return (react_1.default.createElement("span", { className: `${mergedClasses.root} ${muted && "muted"} ${classNames}`, style: style }, render ? render(muted) : icon));
}
exports.default = PeerMutedBadge;
//# sourceMappingURL=PeerMuted.js.map